const MIN_NUM_PANEL_BUTTONS = 2;
export function calcNumVisiblePanelButtons(panelTypes, appDimensions, reservedWidthPx, panelButtonWidthPx, morePanelsButtonWidthPx) {
    if (!appDimensions) {
        return;
    }
    const { w: appWidth } = appDimensions;
    if (appWidth - reservedWidthPx >= panelTypes.length * panelButtonWidthPx) {
        // all can be rendered, no need for 'More Panels' button
        return panelTypes.length;
    }
    if (appWidth < reservedWidthPx + morePanelsButtonWidthPx) {
        return MIN_NUM_PANEL_BUTTONS;
    }
    return Math.max(MIN_NUM_PANEL_BUTTONS, Math.floor((appWidth - reservedWidthPx - morePanelsButtonWidthPx) / panelButtonWidthPx));
}
